import { useMutation, useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import { campaignContactKeys } from "routes/campaign/components/campaign_contact_table/queryKeys";
import { contactKeys } from "routes/contact/components/contacts_table/queryKeys";
import ContactService from "services/Contact";
import EntityService from "services/Entity";

// ["contact"] covers the record page queries, whose keys also carry the
// disabled-tags filter. The tables live under their own factory roots, and the
// record page also reads the contact's entity.
const invalidateContacts = (_, { entityId }) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: ["contact"] }),
    queryClient.invalidateQueries({ queryKey: ["entity", entityId] }),
    queryClient.invalidateQueries({ queryKey: contactKeys.all }),
    queryClient.invalidateQueries({ queryKey: campaignContactKeys.all }),
  ]);

export const useContact = id =>
  useQuery({
    queryKey: ["contact", id],
    queryFn: () => ContactService.getContact(id),
    enabled: !!id,
    retry: false,
  });

export const useContactMutations = () => {
  const create = useMutation({
    mutationFn: ({ entityId, data }) =>
      EntityService.addContact(entityId, data),
    onSuccess: invalidateContacts,
  });

  const update = useMutation({
    mutationFn: ({ entityId, id, data }) =>
      EntityService.editContact(entityId, id, data),
    onSuccess: invalidateContacts,
  });

  return { create, update };
};
